export const DEFAULT_SAT_MINIMUM_SCORE = 1000;
export const MINIMUM_FREE_POINTS_SCORE_FOR_PAYWALL = 20;
